import { ConstantsPage } from '../ConstantsPage';

export function Constants300() {
  return <ConstantsPage version="3.0.0" />;
}
